<template>
  <div>
    <br />
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class v-if="data.response && data.response.client_id != ''">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="pt-4"></div>
    <div class="row mb-12">
      <div class="col-md-3">
        <label for="billing_month"
          >Referente ao mês (mm/yyyy) <span class="m--font-danger">*</span></label
        >
        <div class="input-group">
          <input
            id="billing_month"
            type="text"
            ref="billing_month"
            class="form-control m-input"
            placeholder="mm/aaaa"
            v-model="data.billing_month"
            v-mask="'##/####'"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label for="companies_month">Cliente <span class="m--font-danger">*</span></label>
        <SelectCustomers
          ref="customer_id"
          :selected="data.customer_id"
          :first="'Selecione um cliente'"
          :filteredClient="true"
          @change="updateCustomerIdValue"
        />
      </div>
      <div class="col-md-3">
        <label for="companies_month"> Contrato para visualizar consumo de Chatbot </label>
        <SelectContracts
          ref="contract_id"
          :contractsSelect="contractsSelect"
          :first="'Selecione um contrato'"
          @change="updateContractId"
          :selected="data.contract_id"
          :disabled="!!data.id"
        />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <tr>
                    <th>ID Cliente</th>
                    <td>{{ data.response.client_id }}</td>
                  </tr>
                  <tr>
                    <th>ID Contrato Chatbot</th>
                    <td>{{ data.response.chatbot_contract_id }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Contatos Receptivos</th>
                    <td>{{ data.response.mktzapContacts }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Licenças</th>
                    <td>{{ data.response.mktzapLicenses }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Números</th>
                    <td>{{ data.response.mktzapNumbers }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Ativos Únicos</th>
                    <td>{{ data.response.mktzapActiveUnique }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Ativos SMS</th>
                    <td>{{ data.response.mktzapActiveSms }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Ativos Campanha</th>
                    <td>{{ data.response.mktzapActiveCampaign }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Ativos Campanha SMS</th>
                    <td>{{ data.response.mktzapActiveCampaignSms }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Auto Negociador</th>
                    <td>{{ data.response.mktzapAutoNegociator }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Contatos + Envios de Ativos</th>
                    <td>{{ data.response.mktzapContactUnified }}</td>
                  </tr>
                  <tr>
                    <th>Mktzap Atendimento / Protocolo</th>
                    <td>{{ data.response.mktzapAttendanceProtocol }}</td>
                  </tr>
                  <tr>
                    <th>Chatbot Atendimento</th>
                    <td>{{ data.response.chatbotProcolos }}</td>
                  </tr>
                  <tr>
                    <th>Chatbot Contato/Agenda</th>
                    <td>{{ data.response.chatbotAgenda }}</td>
                  </tr>
                  <tr>
                    <th>Chatbot CPFs - Únicos</th>
                    <td>{{ data.response.chatbotCpfUniq }}</td>
                  </tr>
                  <tr>
                    <th>Enterprise HSM</th>
                    <td>{{ data.response.enterpriseHSM }}</td>
                  </tr>
                  <tr>
                    <th>Enterprise UAM</th>
                    <td>{{ data.response.enterpriseUAM }}</td>
                  </tr>
                  <tr>
                    <th>Quantidade de Mensagens</th>
                    <td>{{ data.response.quantityMessages }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.response.length > 0"
                  >Exibindo {{ data.response.length }} contratos.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerModal v-if="showCustomerSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerModal from '@/components/customers/CustomerModal';
import SelectCustomers from '@/components/forms/SelectCustomers';
import SelectContracts from '@/components/forms/SelectContracts';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportConsumptionAnalytics',
  props: ['start', 'finish'],
  components: { CustomerModal, SelectCustomers, SelectContracts },
  data() {
    return {
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      data: {
        billing_month: '',
        customers: '',
        response: [],
        customer_id: null,
        contract_id: null,
      },
      contractsSelect: [],
      sortType: localStorage.customerSortType ? localStorage.customerSortType : 'id',
      sortReverse: localStorage.customerSortReverse ? localStorage.customerSortReverse : false,
      amount: localStorage.customerDataAmount ? localStorage.customerDataAmount : 100,
      page: localStorage.customerDataPage ? localStorage.customerDataPage : 1,
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
        name: localStorage.customerFilterName ? localStorage.customerFilterName : '',
        cnpj: localStorage.customerFilterCnpj ? localStorage.customerFilterCnpj : '',
        status: localStorage.customerFilterStatus ? localStorage.customerFilterStatus : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
  },
  methods: {
    updateCustomerIdValue(customer_id) {
      this.contractsSelect = [];
      this.data.customer_id = customer_id;

      axios(
        `${baseApiUrl}/v1/customer/contract/get-by-customer?customer_id=${customer_id}&product_id=7`
      ).then((res) => {
        this.contractsSelect = res.data;
      });
    },
    updateContractId(contract_id) {
      this.data.contract_id = contract_id;
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando relatório',
        reason: '',
      };

      const url = `${baseApiUrl}/v1/customer/contract/comsumptions/download/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.clearAlert();

          const arrData = res.data;

          const lineArray = [];
          let csvContent = 'data:text/csv;charset=utf-8,';

          Object.keys(arrData).forEach((key) => {
            const line = `${key};${arrData[key] != null ? arrData[key] : ''}`;

            lineArray.push(line);
          });

          csvContent += lineArray.join('\n').replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_analitico_consumos`;

          fileName += `_${this.data.billing_month}_cliente_${this.data.customer_id}`;

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.sortType = 'id';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
      localStorage.setItem('customerFilterName', this.filters.name);
      localStorage.setItem('customerFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerFilterStatus', this.filters.status);
      localStorage.setItem('customerDataAmount', this.amount);
      localStorage.setItem('customerDataPage', this.page);
      localStorage.setItem('customerSortType', this.sortType);
      localStorage.setItem('customerSortReverse', this.sortReverse);
      localStorage.setItem('customerFilterMonth', this.filters.month);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.data.customer_id ? this.data.customer_id : ''
      }&contract_id=${this.data.contract_id ? this.data.contract_id : ''}&name=${
        this.filters.name ? this.filters.name : ''
      }&cnpj=${this.filters.cnpj ? this.filters.cnpj : ''}&status=${
        this.filters.status ? this.filters.status : ''
      }&amount=${this.amount}&sortType=${this.sortType}&month=${
        this.data.billing_month
      }&customers=${this.data.customers}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}&start=${
        this.start
      }&end=${this.finish}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();

      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contract/comsumptions/search/${this.convertFilters()}`;

      axios(url).then((res) => {
        this.data.response = res.data;

        if (this.data.response.status) {
          this.$toasted.show(
            `<i class="fas fa-exclamation-triangle"></i> ${this.data.response.message}`,
            {
              theme: 'toasted-primary',
              type: 'info',
              position: 'top-right',
              duration: 5000,
            }
          );
        }

        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
